import { Localizzazione } from './localizzazione';

export class Preferito {
  id: string;
  language: string;
  idUser: string;
  idPoi: string;
  typeElement: {
    key?: string;
    label?: string;
  };
  title: string;
  shortDescription: string;
  thumbnail: string;
  province: string;
  city: string;
  geoLocation: Localizzazione;
}
